import { render, staticRenderFns } from "./Diplomes.vue?vue&type=template&id=79c9d91a"
import script from "./Diplomes.vue?vue&type=script&lang=js"
export * from "./Diplomes.vue?vue&type=script&lang=js"
import style0 from "./Diplomes.vue?vue&type=style&index=0&id=79c9d91a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports